import React from 'react';
import { Target, Lightbulb, Users, Shield, Award, Heart, Leaf, FileCheck, CheckCircle2 } from 'lucide-react';
import { ValueCard } from '../components/ValueCard';
import { SEOSchema } from '../components/SEOSchema';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutPage() {
  const {
    t
  } = useLanguage();
  return <div className="pt-20 min-h-screen bg-white" data-id="element-303">
      <SEOSchema type="about" title={t('Tentang Kami | PT Graha Riau Gemilang Developer Properti', 'About Us | PT Graha Riau Gemilang Real Estate Developer')} description={t('Mengenal PT Graha Riau Gemilang, pengembang properti berpengalaman lebih dari 20 tahun dengan puluhan proyek hunian dan komersial.', 'Learn about PT Graha Riau Gemilang, a well-established real estate developer in Riau with over 20 years of experience and proven projects.')} breadcrumbs={[{
      name: t('Beranda', 'Home'),
      url: 'https://grahariaugemilang.com/'
    }, {
      name: t('Tentang Kami', 'About Us'),
      url: 'https://grahariaugemilang.com/tentang-kami'
    }]} data-id="element-304" />

      {/* Header */}
      <div className="bg-gray-50 py-16" data-id="element-305">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-306">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-307">
            {t('Tentang Kami', 'About Us')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-308">
            {t('Mengenal lebih dekat PT Graha Riau Gemilang, pengembang properti terpercaya di Riau.', 'Learn about PT Graha Riau Gemilang, a well-established real estate developer in Riau.')}
          </p>
        </div>
      </div>

      {/* Company Profile */}
      <section className="py-20" data-id="element-309">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-310">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-311">
            <div className="lg:w-1/2" data-id="element-312">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-313">
                {t('Profil Perusahaan', 'Company Profile')}
              </h2>
              <div className="prose prose-lg text-gray-600" data-id="element-314">
                <p className="mb-4" data-id="element-315">
                  {t('PT Graha Riau Gemilang merupakan perusahaan pengembang properti yang berdiri sejak 7 April 2005. Dengan pengalaman lebih dari 20 tahun, kami telah menyelesaikan puluhan proyek hunian dan komersial yang menjadi pilihan ribuan keluarga Indonesia.', 'Founded on April 7, 2005, PT Graha Riau Gemilang is a well-established real estate development company with over 20 years of experience. We have successfully delivered dozens of residential and commercial projects, earning the trust of thousands of homeowners and business partners.')}
                </p>
                <p data-id="element-316">
                  {t('Komitmen kami adalah menghadirkan properti dengan standar kualitas tinggi, inovatif, dan memberikan nilai jangka panjang bagi penghuni maupun investor.', 'Our commitment lies in delivering properties that meet high quality standards, incorporate innovation, and provide long-term value.')}
                </p>
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-317">
              <div className="rounded-2xl overflow-hidden shadow-premium-lg" data-id="element-318">
                <img src="https://cdn.magicpatterns.com/uploads/9Xm28KaLFmnTEqcYBohmkM/PT.-Graha-riau-gemilang_MSDL.jpg" alt="Kantor PT Graha Riau Gemilang" className="w-full h-auto object-cover" data-id="element-319" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Legal Documentation Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white" data-id="element-320">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321">
          <div className="text-center mb-12" data-id="element-322">
            <div className="inline-block p-3 bg-green-50 rounded-full mb-4" data-id="element-323">
              <FileCheck className="w-8 h-8 text-green-600" data-id="element-324" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-325">
              {t('Legalitas Perusahaan', 'Legal Documentation')}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-326">
              {t('Dokumen resmi dan legalitas lengkap untuk keamanan dan kepercayaan Anda.', 'Complete official documentation and legal compliance for your security and trust.')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-327">
            {/* Legal Documents Card */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-premium p-8" data-id="element-328">
              <div className="flex items-center mb-6" data-id="element-329">
                <div className="bg-green-100 p-3 rounded-full text-green-600 mr-4" data-id="element-330">
                  <FileCheck className="w-8 h-8" data-id="element-331" />
                </div>
                <div data-id="element-332">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-333">
                    {t('Dokumen Resmi', 'Official Documents')}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-334">
                    PT Graha Riau Gemilang
                  </p>
                </div>
              </div>

              <ul className="space-y-4" data-id="element-335">
                <li className="flex items-start" data-id="element-336">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-337" />
                  <div data-id="element-338">
                    <span className="block font-medium text-gray-900" data-id="element-339">
                      {t('Akta Pendirian No. 97', 'Deed of Establishment No. 97')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-340">
                      {t('Notaris H. Asman Yunus, S.H. • 7 April 2005', 'Notary H. Asman Yunus, S.H. • April 7, 2005')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-341">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-342" />
                  <div data-id="element-343">
                    <span className="block font-medium text-gray-900" data-id="element-344">
                      {t('SK Menteri Kehakiman', 'Ministry of Justice Decree')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-345">
                      No. C-264 HT.03.01 • 2005
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-346">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-347" />
                  <div data-id="element-348">
                    <span className="block font-medium text-gray-900" data-id="element-349">
                      {t('SIUP Menengah', 'Trading Business License (SIUP – Medium)')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-350">
                      {t('Izin Usaha Perdagangan • 2005', 'Business Trading Permit • 2005')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-351">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-352" />
                  <div data-id="element-353">
                    <span className="block font-medium text-gray-900" data-id="element-354">
                      TDP & NPWP
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-355">
                      {t('Terdaftar dan Patuh Pajak • Aktif', 'Company Registration & Tax ID • Active')}
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* REI Membership Card */}
            <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl border-2 border-blue-200 shadow-premium p-8" data-id="element-356">
              <div className="flex items-center mb-6" data-id="element-357">
                <img src="https://cdn.magicpatterns.com/uploads/xuBA4FLWNXtKdE4fyjLLfC/logoREI.png" alt="REI Logo" className="h-16 w-16 object-contain mr-4" data-id="element-358" />
                <div data-id="element-359">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-360">
                    {t('Anggota Resmi REI', 'Official REI Member')}
                  </h3>
                  <p className="text-sm text-gray-600 font-semibold" data-id="element-361">
                    {t('No. Registrasi: 09.00466', 'Registration No: 09.00466')}
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-362">
                <p className="text-gray-700 leading-relaxed" data-id="element-363">
                  {t('Sebagai anggota Real Estat Indonesia (REI), asosiasi pengusaha real estat terbesar di Indonesia yang didirikan tahun 1972, kami berkomitmen menjalankan praktik bisnis properti yang profesional, etis, dan sesuai standar industri nasional.', 'As a member of Real Estat Indonesia (REI), the largest real estate association in Indonesia established in 1972, we are committed to professional, ethical, and industry-standard property business practices.')}
                </p>

                <div className="bg-white/60 rounded-lg p-4 border border-blue-200" data-id="element-364">
                  <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-365">
                    <Award className="w-5 h-5 text-blue-600 mr-2" data-id="element-366" />
                    {t('Manfaat Keanggotaan REI', 'REI Membership Benefits')}
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700" data-id="element-367">
                    <li className="flex items-start" data-id="element-368">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-369" />
                      <span data-id="element-370">
                        {t('Standar etika bisnis properti nasional', 'National property business ethics standards')}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-371">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-372" />
                      <span data-id="element-373">
                        {t('Jaminan kualitas dan profesionalisme', 'Quality and professionalism guarantee')}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-374">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-375" />
                      <span data-id="element-376">
                        {t('Perlindungan hak konsumen properti', 'Property consumer rights protection')}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Badge */}
          <div className="mt-8 text-center" data-id="element-377">
            <div className="inline-flex items-center space-x-2 px-6 py-3 bg-green-50 border border-green-200 rounded-full" data-id="element-378">
              <Shield className="w-5 h-5 text-green-600" data-id="element-379" />
              <span className="text-sm font-semibold text-green-800" data-id="element-380">
                {t('Legalitas Terjamin & Terdaftar Resmi', 'Guaranteed Legal Compliance & Officially Registered')}
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="py-20 bg-[#C4161C] text-white" data-id="element-381">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-382">
          <div className="inline-block p-3 bg-white/10 rounded-full mb-6" data-id="element-383">
            <Target className="w-8 h-8" data-id="element-384" />
          </div>
          <h2 className="text-3xl font-bold mb-6" data-id="element-385">
            {t('Visi Kami', 'Our Vision')}
          </h2>
          <p className="text-2xl font-medium leading-relaxed" data-id="element-386">
            {t('"Menjadi developer properti terkemuka di Riau yang menghadirkan hunian berkualitas tinggi, berkelanjutan, dan menciptakan komunitas yang harmonis untuk generasi mendatang."', '"To become a leading real estate developer in Riau by delivering high-quality, sustainable properties and fostering harmonious communities for future generations."')}
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 bg-gray-50" data-id="element-387">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-388">
          <div className="text-center mb-16" data-id="element-389">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-390">
              {t('Misi Kami', 'Our Mission')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-391">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-392">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-[#C4161C] mb-6" data-id="element-393">
                <Shield className="w-6 h-6" data-id="element-394" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-395">
                {t('Kualitas Terjamin', 'Guaranteed Quality')}
              </h3>
              <p className="text-gray-600" data-id="element-396">
                {t('Menghadirkan properti dengan standar kualitas internasional dan material terbaik.', 'Deliver properties with high construction standards and premium materials.')}
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-397">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-[#C4161C] mb-6" data-id="element-398">
                <Lightbulb className="w-6 h-6" data-id="element-399" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-400">
                {t('Inovasi Berkelanjutan', 'Sustainable Innovation')}
              </h3>
              <p className="text-gray-600" data-id="element-401">
                {t('Mengembangkan desain hunian yang modern, ramah lingkungan, dan efisien energi.', 'Develop modern, environmentally conscious, and energy-efficient designs.')}
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-402">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-[#C4161C] mb-6" data-id="element-403">
                <Users className="w-6 h-6" data-id="element-404" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-405">
                {t('Kepercayaan Pelanggan', 'Customer Trust')}
              </h3>
              <p className="text-gray-600" data-id="element-406">
                {t('Memberikan layanan transparan, profesional, dan purna jual yang responsif.', 'Provide transparent services and responsive after-sales support.')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-white" data-id="element-407">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408">
          <div className="text-center mb-16" data-id="element-409">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-410">
              {t('Nilai-Nilai Inti Perusahaan', 'Core Values')}
            </h2>
            <p className="text-gray-600" data-id="element-411">
              {t('Fondasi yang menjadi pegangan kami dalam setiap langkah.', 'The foundation that guides us in every step.')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-412">
            <ValueCard icon={Shield} title={t('Integritas', 'Integrity')} description={t('Komitmen pada kejujuran dan transparansi.', 'Upholding honesty and transparency in every business process.')} data-id="element-413" />
            <ValueCard icon={Award} title={t('Kualitas', 'Quality')} description={t('Standar tertinggi dalam desain dan konstruksi.', 'Maintaining the highest standards in design, construction, and service.')} data-id="element-414" />
            <ValueCard icon={Heart} title={t('Kepercayaan', 'Trust')} description={t('Hubungan jangka panjang dengan konsumen dan mitra.', 'Building long-term relationships with customers and partners.')} data-id="element-415" />
            <ValueCard icon={Leaf} title={t('Keberlanjutan', 'Sustainability')} description={t('Tanggung jawab terhadap lingkungan dan komunitas.', 'Taking responsibility toward the environment and local communities.')} data-id="element-416" />
          </div>
        </div>
      </section>
    </div>;
}